export enum WsTypes {
  OLD_NOTIFICATION = 'notification',

  SUBSCRIBE = 'subscribe',
  SRM_CHANGED = 'srm_changed',
  TQL_CHANGED = 'tql_changed',
  CIs_CHANGED = 'cis_changed',
  ALERTS_CHANGED = 'alerts_changed',
  HI_CHANGED = 'hi_changed',
  GROUPED_NOTIFICATIONS = 'grouped_notifications',
  CACHED_STORAGE_INVALIDATION = 'cached_storage_invalidation',
  NOTICE = 'notice',
  TEST = 'test',
}

// Нужно для валидации (идет поиск по ключу а он не совпадает с константными названиями
export const WsTypesToValidation = {
  [WsTypes.GROUPED_NOTIFICATIONS]: true,
  [WsTypes.OLD_NOTIFICATION]: true,

  [WsTypes.SUBSCRIBE]: true,
  [WsTypes.SRM_CHANGED]: true,
  [WsTypes.TQL_CHANGED]: true,
  [WsTypes.CIs_CHANGED]: true,
  [WsTypes.ALERTS_CHANGED]: true,
  [WsTypes.HI_CHANGED]: true,
  [WsTypes.NOTICE]: true,
};